var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-space-around":"","column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-progress-circular',{attrs:{"width":3,"color":"rgba(0, 241, 155, 1)","indeterminate":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }